import { ChangeEventHandler } from 'react';
import {
  Grid, Paper, Stack, TextField,
} from '@mui/material';
import { v4 as uuid } from 'uuid';
import BlockProps from '../../../models/BlockProps';
import BlockHtmlData from './BlockHtmlData';
import Utils from '../../../utils/Utils';
import CloseButton from '../../Buttons/Close';
import EditableText from '../../Form/EditableText';

function BlockHtml({
  data, isEditing, isTemplate, editHandler,
}: BlockProps) {
  const props = (data.data as BlockHtmlData);

  const handleHtml: ChangeEventHandler<HTMLInputElement> = (event) => {
    props.html.value = event.target.value;
  };

  const handleBlur: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> = (event) => {
    props.html.value = event.target.value;
    editHandler(data.id, props);
  };

  const handleTitleUpdate = (text: string) => {
    props.title.value = text;
    editHandler(data.id, props);
  };

  return (
    <Stack
      spacing={0}
      sx={{
        padding: 1.5,
        overflow: 'hidden',
      }}
    >
      {(isEditing && !isTemplate) && (
        <Stack spacing={0} sx={{ border: '1px dashed lightGray', p: 2, m: 2 }}>
          <TextField
            key={uuid()}
            label="埋め込みHTML"
            multiline
            rows={4}
            defaultValue={props.html?.value}
            onChange={handleHtml}
            onBlur={handleBlur}
          />
        </Stack>
      )}
      {props.title && (
        <Grid item sx={[Utils.hoverBorder(isEditing), { marginBottom: 2 }]}>
          <CloseButton
            show={isEditing}
            updateHandler={() => {
              props.title = undefined;
              editHandler(data.id, props);
            }}
          />
          <EditableText
            text={props.title.value}
            isEditable={isEditing && !isTemplate}
            updateHandler={handleTitleUpdate}
          />
        </Grid>
      )}
      <Grid
        container
        direction="column"
        sx={{
          justifyContent: 'center', alignItems: 'center', width: '100%', height: 'auto',
        }}
      >
        {props.html.value && (
          <div dangerouslySetInnerHTML={{ __html: props.html.value }} />
        )}
        {!props.html.value && (
          <Paper
            elevation={0}
            sx={{
              width: '100%', height: 450, background: '#F4F4F6', border: '1px dashed lightGray',
            }}
          />
        )}
      </Grid>
    </Stack>
  );
}

export default BlockHtml;
